import type { SortingState } from '@tanstack/table-core'

import {
  columnFilteringFeature,
  createFilteredRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  filterFns,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSortingFeature,
  sortFns,
  tableFeatures
} from '@tanstack/react-table'

import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

import { TransactionType } from '@/types/legacy'

import { EarnTransactionType } from './DashboardActivity.types'

export const dashboardActivityTableFeatures = tableFeatures({
  columnFilteringFeature,
  globalFilteringFeature,
  rowPaginationFeature,
  rowSortingFeature,
  filterFns,
  filteredRowModel: createFilteredRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  sortFns,
  sortedRowModel: createSortedRowModel()
})

export type DashboardActivityTableFeatures = typeof dashboardActivityTableFeatures

export const PAGE_SIZE = 20

export const DASHBOARD_EARN_TRANSACTIONS_STORAGE_KEY = 'dashboardEarnTransactionsTable'

export const DASHBOARD_BORROW_TRANSACTIONS_STORAGE_KEY = 'dashboardBorrowTransactionsTable'

export const DASHBOARD_LIQUIDATION_TRANSACTIONS_STORAGE_KEY =
  'dashboardLiquidationTransactionsTable'

export const EARN_COLUMN_IDS = {
  Timestamp: 'Timestamp',
  AssetsUsd: 'AssetsUsd',
  Type: 'Type',
  Vault: 'Vault',
  TransactionHash: 'TransactionHash',
  Network: 'Network'
} as const

export const BORROW_COLUMN_IDS = {
  Timestamp: 'Timestamp',
  AssetsUsd: 'AssetsUsd',
  Type: 'Type',
  Vault: 'Vault',
  TransactionHash: 'TransactionHash',
  Network: 'Network',
  Market: 'Market'
} as const

export const LIQUIDATION_COLUMN_IDS = {
  Timestamp: 'Timestamp',
  Network: 'Network',
  Market: 'Market',
  CollateralSeized: 'CollateralSeized',
  Liquidator: 'Liquidator',
  TransactionHash: 'TransactionHash',
  LoanRepaid: 'LoanRepaid',
  RealizedBadDebt: 'RealizedBadDebt'
} as const

export const DASHBOARD_TRANSACTIONS_INITIAL_SORTING: SortingState = [
  {
    id: EARN_COLUMN_IDS.Timestamp,
    desc: true
  }
]

export const DASHBOARD_TRANSACTIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: DASHBOARD_TRANSACTIONS_INITIAL_SORTING,
  columnFilters: [],
  columnOrder: [],
  // Bumping version to force resetting user settings
  version: 1
}

export const DASHBOARD_EARN_ACTIVITY_FILTER_OPTIONS = [
  {
    label: 'Deposit',
    value: EarnTransactionType.Deposit
  },
  {
    label: 'Withdraw',
    value: EarnTransactionType.Withdraw
  },
  {
    label: 'Transfer',
    value: EarnTransactionType.Transfer
  }
]

export const DASHBOARD_BORROW_ACTIVITY_FILTER_OPTIONS = [
  {
    label: 'Borrow',
    value: TransactionType.MarketBorrow
  },
  {
    label: 'Repay',
    value: TransactionType.MarketRepay
  },
  {
    label: 'Lend',
    value: TransactionType.MarketSupply
  },
  {
    label: 'Supply Collateral',
    value: TransactionType.MarketSupplyCollateral
  },
  {
    label: 'Withdraw Collateral',
    value: TransactionType.MarketWithdrawCollateral
  }
]
